import { useCallback, useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { logger } from "@/lib/logger";

const POLL_INTERVAL_MS = 60_000;

const isNewerThan = (iso, seenAt) =>
  !seenAt || new Date(iso).getTime() > new Date(seenAt).getTime();

// Marcador "visto até" vive no backend (users.alerts_seen_at) — nada em storage do navegador.
export function useAlerts() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [marking, setMarking] = useState(false);
  const timerRef = useRef(null);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await api.get("/alerts");
      setData(r.data);
    } catch (e) {
      logger.error("Falha ao carregar alertas", e);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => {
    load();
    timerRef.current = setInterval(load, POLL_INTERVAL_MS);
    return () => clearInterval(timerRef.current);
  }, [load]);

  const marcarVistas = useCallback(async () => {
    setMarking(true);
    try {
      const r = await api.put("/alerts/seen");
      setData((prev) => (prev ? { ...prev, seen_at: r.data.seen_at } : prev));
    } catch (e) {
      logger.error("Falha ao marcar alertas como vistos", e);
    } finally { setMarking(false); }
  }, []);

  const seenAt = data?.seen_at || null;
  const novasNovas = (data?.novas?.items || []).filter((it) => isNewerThan(it.created_at, seenAt));
  const docsCount = data?.documentos_pendentes?.count || 0;
  const otpsCount = data?.otps_expirando?.count || 0;
  const totalBadge = novasNovas.length + docsCount + otpsCount;

  return { data, loading, marking, seenAt, novasNovas, docsCount, otpsCount, totalBadge, load, marcarVistas };
}
